import { render, staticRenderFns } from "./modifyOrderDetail1.vue?vue&type=template&id=bccf798e&scoped=true"
import script from "./modifyOrderDetail1.vue?vue&type=script&lang=js"
export * from "./modifyOrderDetail1.vue?vue&type=script&lang=js"
import style0 from "./modifyOrderDetail1.vue?vue&type=style&index=0&id=bccf798e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccf798e",
  null
  
)

export default component.exports